export default "__VITE_ASSET__BpjteNtx__"